import React from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import Button from "../../button/button";
import { ContactData } from "../../../context/ContactData/ContactData";
import useRequests from "../../../Hooks/useRequests";

function ControlsUsersMini({ userId, videoMuted, audioMuted }) {
  const { room } = useParams();
  const { registerActivity } = useRequests();
  const { dataContact, setActionsUsers, usersName } = useContext(ContactData);
  const {
    room: { streaming, attendee },
  } = dataContact;

  const actionsUser = async (type) => {
    var attendeeIO = {
      command: "CONTROL-USER",
      name: attendee.name,
      type: type,
      room: streaming.channel,
      id_user: userId,
      id: room,
      product: "CONTACT",
      product_id: room,
    };

    setActionsUsers(attendeeIO);
  };

  return (
    <div className="controls-mini">
      <Button
        variant={!audioMuted ? "controls-menu-mini" : "off"}
        onClick={() => {
          actionsUser(!audioMuted ? "audio-off" : "audio", "local");
          registerActivity(
            attendee.name,
            room,
            audioMuted ? "MIC_ON_ATT" : "MIC_OFF_ATT",
            "ROOM",
            usersName.find((user) => user.uid === userId).name
          );
        }}
        icon={
          !audioMuted
            ? `${process.env.REACT_APP_CONTACT_IMG}/mic.svg`
            : `${process.env.REACT_APP_CONTACT_IMG}/mic-off.svg`
        }
      >
        <p className="tip-text">
          {!audioMuted ? "Desactivar Micrófono" : "Activar Micrófono"}
        </p>
      </Button>

      <Button
        variant={!videoMuted ? "controls-menu" : "off"}
        onClick={() => {
          actionsUser(!videoMuted ? "video-off" : "video", "local");
          registerActivity(
            attendee.name,
            room,
            videoMuted ? "CAM_ON_ATT" : "CAM_OFF_ATT",
            "ROOM",
            usersName.find((user) => user.uid === userId).name
          );
        }}
        icon={
          !videoMuted
            ? `${process.env.REACT_APP_CONTACT_IMG}/cam.svg`
            : `${process.env.REACT_APP_CONTACT_IMG}/cam-off.svg`
        }
      >
        <p className="tip-text">
          {!videoMuted ? "Desactivar Cámara" : "Activar Cámara"}
        </p>
      </Button>

      <Button
        variant="controls-menu"
        onClick={() => {
          registerActivity(
            attendee.name,
            room,
            "EXIT_ATT",
            "ROOM",
            usersName.find((user) => user.uid === userId).name
          );
          actionsUser("exit");
        }}
        icon={`${process.env.REACT_APP_CONTACT_IMG}/salir.svg`}
      >
        <p className="tip-text">Salir de la sala</p>
      </Button>
    </div>
  );
}

export default ControlsUsersMini;
